import React from 'react';
import { Button, Typography, PriceBlockUs } from '@hpstellar/core/visId';
import { PunchOut, Violator } from '@hpstellar/core';

import useTemplateTheme from '../../../hooks/useTemplateTheme';
import { Helpers } from '../../../core/src/helpers';
import { getCustomSaleText } from '../../../hooks/useProductPrice';

import './price-atc.less';

const PriceAtc = ({ className, price, buttonProps, msrp, showLabel = true, slim, alignment, stacked, isMobile }) => {
    const { button: buttonThemeProps = {} } = useTemplateTheme(['button']);

    if (!price) {
        return null;
    }

    return (
        <div className={`price-atc-container ${className || ''} ${stacked ? 'stacked' : ''}`}>
            <div>
                {price && !price.error && (
                    <div className={`cto-price-container cto-alt-style`}>
                        {showLabel && <Typography variant="footnotes">As configured</Typography>}
                        <PriceBlockUs
                            oldPrice={
                                !isMobile && price.regularPrice > price.salePrice
                                    ? Helpers.formatCurrency(price.regularPrice, '$', true)
                                    : undefined
                            }
                            finalPrice={Helpers.formatCurrency(price.salePrice, '$', true)}
                            saveLabel={getCustomSaleText(price, false, { excludeSuffix: true })}
                            className="price-block"
                            msrp={msrp}
                            finalPriceTypographyVariant="caption"
                            slim={slim}
                            alignment={alignment}
                        />

                        {price.gmPoints && <PunchOut grossMargin={price.gmPoints} />}
                    </div>
                )}
                {price && price.error && <Violator className="price-error" value={price.error} />}
            </div>

            {/* TODO: could be avoided by modifying the text on the api but not sure how thatd work with ab test */}
            <Button
                className="cto-atc"
                {...{
                    ...(buttonProps || {}),
                    children:
                        typeof buttonProps?.children === 'string'
                            ? buttonProps.children.charAt(0).toUpperCase() + buttonProps.children.slice(1).toLowerCase()
                            : buttonProps?.children,
                }}
                theme={buttonThemeProps?.color}
            />
        </div>
    );
};

export default PriceAtc;
